import { render, staticRenderFns } from "./AdminLinks.vue?vue&type=template&id=61dce0a0&scoped=true"
import script from "./AdminLinks.vue?vue&type=script&lang=js"
export * from "./AdminLinks.vue?vue&type=script&lang=js"
import style0 from "./AdminLinks.vue?vue&type=style&index=0&id=61dce0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dce0a0",
  null
  
)

export default component.exports